export default __webpack_public_path__ + "static/media/decorative-image-2.546d3857.jpg";